export const hasInput = function hasInput() {
  let returnHasInput = false;
  if (Array.isArray(this.value)) {
    this.value.forEach((input) => {
      if (Object.prototype.hasOwnProperty.call(input, 'input')) {
        returnHasInput = true;
      }
    });
  }
  return returnHasInput;
};
export const displayValue = function displayValue() {
  if (Array.isArray(this.value)) {
    return this.value.map((input) => {
      if (Object.prototype.hasOwnProperty.call(input, 'input')) {
        return `${input.value} ${input.input} `;
      }
      return `${input.value}`;
    }).join('');
  }
  return this.value;
};


export const assetDiversification = function assetDiversification(diversification) {
  diversification.displayValue = displayValue;
  diversification.hasInput = hasInput;
  return diversification;
};
